import { variablesGlobales } from '../../configs/variables';
import getInstanceAxios from '../axiosInstance';

export class ImportService {
    static async imporRestrictListGalilea(data) {

        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceImports}/api/v1/import/import/createRestrictInListGalilea`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            const jsonData = await responseServer.data;

            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {

            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }


    static async uploadFiles(data) {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceImports}/api/v1/uploadFiles/uploadToS3`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            const jsonData = await responseServer.data;

            return {
                error: false,
                message: jsonData,
                date: new Date(),
                status : responseServer.status
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }
}

